export const PERSON_1 = "images/man 1.png";
export const PERSON_2 = "images/man 2.png";
export const PERSON_3 = "images/man 3.png";
export const PERSON_4 = "images/man 1.png";
export const PERSON_5 = "images/woman 1.png";
export const PERSON_6 = "images/woman 2.png";
export const LOGO_1 = "/logo/aaidank logo-1.png";
export const LOGO_2 = "/logo/aaidank logo-2.png";
